import { Factory } from 'fishery'
import { AdminReports_adminReports as TAdminReport } from '../queries/types/AdminReports'
import { ReportReportType } from '../types/graphql-global-types'

const adminReportFactory = Factory.define<TAdminReport>(({ sequence }) => ({
  __typename: 'Report',
  hashId: `admin-${sequence}`,
  filename: `Admin Report ${sequence}`,
  reportType: ReportReportType.EER,
  rowCount: 100,
  startDate: '2024-01-01',
  endDate: '2024-01-31',
  approved: true,
}))

export { adminReportFactory }
